/**系统更新日志 */
export default [
    {
        name:'updaterecord',
        path:'updaterecord',
        meta: { title: '系统更新日志' },
        component: ()=>import('@/pages/updaterecord/index.vue')
    }
]